module.exports = __webpack_public_path__ + "img/loader-white.4d0dd560.svg";